export enum ModeEnum {
  SEQUENCE = 'SEQUENCE',
  PROJECT = 'PROJECT',
}
